import { CannedJobExpanded, CannedJobMotorLaborEntry } from '../../../sdk'

interface LaborTaxonomy {
  system: number
  group: number | undefined
  subgroup: number | undefined
  taxonomy: number | undefined
}

const matchLaborTaxonomy = (
  searchedId: number | undefined,
  laborId: number | undefined
) => {
  return (
    // if all levels are matched, cannedJob is returned
    // if higher levels are matched and search is more specific than cannedJobMotorLabor, cannedJob is returned
    // if higher levels are matched and cannedJobMotorLabor is more specific than search, cannedJob is returned
    searchedId === undefined || laborId === undefined || searchedId === laborId
  )
}

const matchAtLeastOneLabor = (
  labor: CannedJobMotorLaborEntry,
  laborTaxonomy: LaborTaxonomy
) => {
  const cannedJobTaxonomy = labor.info!.taxonomy!
  const { system, group, subgroup, taxonomy } = laborTaxonomy
  return (
    matchLaborTaxonomy(
      system,
      cannedJobTaxonomy.system && cannedJobTaxonomy.system.id!
    ) &&
    matchLaborTaxonomy(
      group,
      cannedJobTaxonomy.group && cannedJobTaxonomy.group.id!
    ) &&
    matchLaborTaxonomy(
      subgroup,
      cannedJobTaxonomy.subgroup && cannedJobTaxonomy.subgroup.id!
    ) &&
    matchLaborTaxonomy(taxonomy, cannedJobTaxonomy.taxonomyId)
  )
}

const includesSearchedLabor = (
  cannedJobMotorLabor: CannedJobMotorLaborEntry[],
  laborTaxonomy: LaborTaxonomy
) => {
  for (const labor of cannedJobMotorLabor) {
    if (matchAtLeastOneLabor(labor, laborTaxonomy)) {
      return true
    }
  }
  return false
}

export const browseCannedJobs = (
  cannedJobs: CannedJobExpanded[],
  laborTaxonomy: LaborTaxonomy
) => {
  return cannedJobs.filter((job) =>
    includesSearchedLabor(job.motorLabor!, laborTaxonomy)
  )
}
